import { render, staticRenderFns } from "./GeneralUploader.vue?vue&type=template&id=bb337804&scoped=true&"
import script from "./GeneralUploader.vue?vue&type=script&lang=js&"
export * from "./GeneralUploader.vue?vue&type=script&lang=js&"
import style0 from "./GeneralUploader.vue?vue&type=style&index=0&id=bb337804&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb337804",
  null
  
)

export default component.exports